<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8135 6.9454C10.8135 5.87206 11.6788 5.00195 12.7463 5.00195C13.8137 5.00195 14.679 5.87206 14.679 6.9454C14.679 8.01873 13.8137 8.88884 12.7463 8.88884C12.2337 8.88884 11.742 8.68408 11.3796 8.31962C11.0171 7.95515 10.8135 7.46083 10.8135 6.9454Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M15.8743 18.3292C16.0576 18.307 16.2237 18.2097 16.3335 18.0604C16.4432 17.9111 16.4868 17.7229 16.4541 17.5401L15.2365 12.2928C15.0848 11.6597 14.5636 11.1842 13.9222 11.0937C13.806 11.0776 13.6885 11.1122 13.5994 11.189L13.0795 11.634C12.8323 11.8461 12.4685 11.8461 12.2213 11.634L11.7014 11.189C11.6133 11.1133 11.4974 11.0787 11.3825 11.0937C10.7416 11.1877 10.2233 11.6665 10.0759 12.3006L8.85827 17.5479C8.82555 17.7306 8.8692 17.9189 8.97894 18.0682C9.08867 18.2175 9.25478 18.3147 9.43811 18.3369C9.52561 18.3484 9.61454 18.3412 9.69904 18.3156L9.1192 20.7526C9.09173 20.8802 9.12312 21.0133 9.20459 21.1149C9.28606 21.2164 9.40886 21.2755 9.53861 21.2754H11.2588L11.597 25.071C11.6334 25.3943 11.9055 25.6385 12.2291 25.6385H13.0833C13.4069 25.6385 13.679 25.3943 13.7154 25.071L14.0536 21.2754H15.7738C15.9035 21.2755 16.0263 21.2164 16.1078 21.1149C16.1893 21.0133 16.2207 20.8802 16.1932 20.7526L15.6134 18.3156C15.6978 18.3383 15.786 18.3429 15.8724 18.3292H15.8743Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M26.5422 8.8986C27.6096 8.8986 28.4749 8.02849 28.4749 6.95516C28.4749 5.88183 27.6096 5.01172 26.5422 5.01172C25.4747 5.01172 24.6094 5.88183 24.6094 6.95516C24.6094 8.02849 25.4747 8.8986 26.5422 8.8986V8.8986Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M23.0772 12.9088L23.5527 16.508C23.6123 17.0341 23.9625 17.481 24.4572 17.6624L25.2593 25.0475C25.2966 25.3701 25.5684 25.6133 25.8913 25.6131H27.1612C27.4837 25.6132 27.7549 25.3698 27.7913 25.0475L28.5914 17.6624C29.1016 17.4889 29.4662 17.0345 29.5269 16.4964L30.0024 12.8971C30.0553 12.4315 29.908 11.9652 29.5975 11.6156C29.2871 11.2659 28.843 11.0661 28.3769 11.0664H27.7043C27.6237 11.0757 27.5477 11.1089 27.4859 11.1616L26.966 11.6067C26.7188 11.8188 26.355 11.8188 26.1078 11.6067L25.5918 11.1714C25.5305 11.1189 25.4552 11.0858 25.3753 11.0761H24.7027C24.2362 11.0758 23.7917 11.2759 23.4812 11.6259C23.1707 11.976 23.0237 12.4428 23.0772 12.9088Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8956 31.7522C19.9564 31.7035 20.0429 31.7035 20.1038 31.7522L23.7953 34.7055C23.9184 34.8039 23.8488 35.0023 23.6912 35.0023H16.3081C16.1506 35.0023 16.081 34.8039 16.204 34.7055L19.8956 31.7522Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M5 28.835L35 28.835"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "GenderBalanceIcon",
});
</script>
